import { coalesceLocaleField } from './../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { createArticleTagsProjection } from './createArticleTagsProjection'
import { createMediaProjection } from './createMediaProjection'
import { createSEOProjection } from './createSEOProjection'
import { createTagsProjection } from './createTagsProjection'

export const createArticlesLandingPageProjection = (localeId: string) => {
  const MEDIA_PROJECTION = createMediaProjection(localeId)
  const SEO_PROJECTION = createSEOProjection(localeId)
  const TAGS_PROJECTION = createTagsProjection(localeId)
  const ARTICLE_TAGS_PROJECTION = createArticleTagsProjection(localeId)

  return groq`{
      "type":_type,
      "showFooter": true,
      "headerStyle":"transparent-dark",
      "footerMobileButtonVisible":false,
      "seo": seo${SEO_PROJECTION},
      "pageBuilder": [{
         "_type": "sectionArticlesLandingPage",
         "_key": "sectionArticlesLandingPage" + _id,
         ${coalesceLocaleField('title', localeId)},
         articles[]->{
          thumbnail${MEDIA_PROJECTION},
          ${coalesceLocaleField('title', localeId)},
          "path":path.current,
          tags[]->${TAGS_PROJECTION},
         },
        "tags": ${ARTICLE_TAGS_PROJECTION}
      }]
  }`
}
